import styled from "styled-components";

export const InvestmentContainer = styled.div`
  margin-inline: 15px;
  min-height: 110vh;
`;

export const InvestmentTopCard = styled.div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  margin-block-start: 20px;
  font-weight: bold;
`;

// export const InvestmentMinersCard = styled.div`
//     padding: 20px;
//     background-color: #7B36EE;
//     color: ${({theme}) => theme.colors.primary};
//     height: 80px;
//     width: calc(100% - 40px);
//     font-size: larger;
//     cursor: pointer;
// `

export const InvestmentBalanceCard = styled.div`
  /* height: 100px; */
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  /* width: calc(100% - 40px); */
  margin-block: 5px;
`;

export const InvestmentBalanceButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  border-radius: 15px;
  width: calc(100% - 10px);
  height: 35px;
  font-weight: bold;
  margin-inline: 5px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const MachineCardContainer = styled.div`
  margin-top: 30px;
`;

export const MachineCard = styled.div`
  display: flex;
  justify-content: space-evenly;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 0px;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;
export const MachineCardImg = styled.img`
  width: 170px;
  height: 140px;
  object-fit: cover;
`;

export const MachineBuyCardContainer = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.45);

  @media only screen and (min-width: 500px) {
    width: 500px;
  }
`;
export const MachineBuyCard = styled(MachineCard)`
  flex-direction: column;
  width: 100vw;
  margin-inline: 10px;
  cursor: default;
`;

export const MachineValueText = styled.div`
  color: ${({ theme }) => theme.colors.link.text};
`;
